


















































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const authModule = namespace('auth');

@Component
export default class Login extends Vue {
  @authModule.Action login!: any;

  bgClass = '';
  isLoading = false;

  @authModule.State accessToken!: string;
  form = {
    email: '',
    password: '',
    remember: false,
  };

  created() {
    this.bgClass = `bg-${Math.floor(Math.random() * (10 - 1 + 1)) + 1}`;
  }

  submitForm() {
    this.isLoading = true;

    const router = this.$router;
    this.login(this.form)
      .then(() => {
        this.isLoading = false;
        router.push('/');
      })
      .catch((err: any) => {
        this.isLoading = false;
        throw new Error(err);
      });
  }
}
